import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// Shared enterprise design tokens for auth pages (matches marketing system)
export const AUTH_PAGE_BG = '#F8FAFC';
export const AUTH_BORDER = '#E4E9F0';
export const AUTH_SUBTLE = '#5B6678';
export const AUTH_LABEL = '#344054';
export const AUTH_BLUE = '#1E4ED8';
export const AUTH_NAVY = '#13294B';

export function AuthLogo({ className = '' }) {
  return (
    <div className={`w-12 h-12 rounded-md flex items-center justify-center ${className}`} style={{ background: AUTH_BLUE }}>
      <span className="text-white font-bold text-2xl" style={{ fontFamily: 'Archivo' }}>D</span>
    </div>
  );
}

export function AuthShell({ children, maxWidth = 'max-w-md', backTo = '/', backLabel = 'Back to Home', showLegal = false, header = null }) {
  return (
    <div className="dr-marketing min-h-screen flex items-center justify-center p-4" style={{ background: AUTH_PAGE_BG }}>
      <div className={`w-full ${maxWidth}`}>
        {backTo && (
          <Link to={backTo} className="inline-flex items-center gap-2 mb-6 text-[15px] font-medium hover:opacity-70" style={{ color: AUTH_SUBTLE }}>
            <ArrowLeft className="w-4 h-4" /> {backLabel}
          </Link>
        )}
        {header}
        <div className="bg-white rounded-[10px] border p-8" style={{ borderColor: AUTH_BORDER, boxShadow: '0 1px 3px rgba(19,41,75,.06)' }}>
          {children}
        </div>
        {showLegal && (
          <div className="flex justify-center gap-5 mt-6 text-xs">
            <a href="/terms" style={{ color: AUTH_SUBTLE }} className="hover:opacity-70">Terms</a>
            <a href="/privacy" style={{ color: AUTH_SUBTLE }} className="hover:opacity-70">Privacy</a>
            <a href="/disclaimer" style={{ color: AUTH_SUBTLE }} className="hover:opacity-70">Disclaimer</a>
          </div>
        )}
      </div>
    </div>
  );
}

// Flat blue primary submit button
export function PrimaryButton({ children, className = '', style = {}, ...props }) {
  return (
    <button
      className={`w-full h-12 rounded-md font-semibold text-white transition hover:opacity-90 disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
      style={{ background: AUTH_BLUE, fontFamily: "'Source Sans 3', sans-serif", ...style }}
      {...props}
    >
      {children}
    </button>
  );
}

// White bordered secondary/Google button
export function OutlineButton({ children, className = '', style = {}, ...props }) {
  return (
    <button
      className={`w-full h-12 rounded-md font-medium flex items-center justify-center gap-3 bg-white transition hover:bg-slate-50 disabled:opacity-60 ${className}`}
      style={{ border: `1px solid ${AUTH_BORDER}`, color: '#1D2939', fontFamily: "'Source Sans 3', sans-serif", ...style }}
      {...props}
    >
      {children}
    </button>
  );
}

export function GoogleIcon() {
  return (
    <svg className="w-5 h-5" viewBox="0 0 24 24">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
    </svg>
  );
}
